import { getURLForRedirectionThroughEnterpret } from '@modules/common/utils';
import { KEYWORD_SUMMARY_REDIRECTION_TAG } from '@modules/common/utils/getURLForRedirectionThroughEnterpret';
import { IntegrationChannelType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

export const getAudioSnippetSourceURL = (
  externalSourceLink: string | undefined,
  channelType: IntegrationChannelType | undefined,
  startTime: number,
  endTime: number,
  tenantName: string,
  tenantID: UUID,
) => {
  if (!externalSourceLink || !channelType) {
    return undefined;
  }

  let snippetURL: string;

  switch (channelType) {
    case IntegrationChannelType.Gong:
      snippetURL = `${externalSourceLink}&highlights=${encodeURIComponent(
        JSON.stringify([
          {
            type: 'SHARE',
            from: Math.floor(startTime),
            to: Math.floor(endTime),
          },
        ]),
      )}`;
      break;
    default:
      return undefined;
  }

  return getURLForRedirectionThroughEnterpret(
    snippetURL,
    tenantName,
    tenantID,
    KEYWORD_SUMMARY_REDIRECTION_TAG,
  );
};
